import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Button from 'layout/atoms/Button/Button';
import Label from 'layout/atoms/Label';
import Modal from 'layout/atoms/Modal/Modal';
import { closeModal } from 'store/layoutSlice';
import styles from './ConfirmationModal.module.scss';
function ConfirmationModal({ name, header, text, buttons, action, loading, subheader, children, }) {
    const { t } = useTranslation('common');
    const dispatch = useDispatch();
    const handleCancel = () => {
        dispatch(closeModal({ name }));
    };
    const handleConfirm = () => {
        if (action) {
            action();
            dispatch(closeModal({ name }));
        }
    };
    return (React.createElement(Modal, { name: name, size: "s", header: React.createElement(Label, { weight: "strong" }, header), subheader: subheader, footer: buttons || (React.createElement(React.Fragment, null,
            React.createElement(Button, { theme: "ghost", onClick: handleCancel }, t('cancel')),
            React.createElement(Button, { color: "primary", onClick: handleConfirm, submit: true, loading: loading }, t('confirm')))) },
        React.createElement("div", { className: styles.content },
            children && children,
            text && React.createElement("p", null, text))));
}
export default ConfirmationModal;
